import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { applyBrandColor } from "@/lib/brandColor";

const DEFAULT = { trial_days: 7, logo_url: "", brand_color: "" };
let cache = null;
let pending = null;
const subs = new Set();

export const getBranding = () => cache;

export function setBranding(b) {
  cache = b;
  applyBrandColor(b.brand_color);
  subs.forEach((f) => f(b));
}

function load() {
  if (!pending) pending = api.get("/public/branding").then((r) => setBranding(r.data)).catch(() => {});
  return pending;
}

export function useBranding() {
  const [b, setB] = useState(cache || DEFAULT);
  useEffect(() => {
    subs.add(setB);
    if (cache) setB(cache);
    else load();
    return () => { subs.delete(setB); };
  }, []);
  return b;
}
